<template>
  <div class="sampleStatus" :class="className" v-if="kit">
    <div class="w-100">
        <strong class="text-muted">STATUS</strong>
    </div>
    <div class="mb-3 w-100">
        <h4 class="status" >{{displayPrefex}}{{displayStatus}}</h4>
        <span>{{subStatus}}</span>
    </div>


    <b-popover placement="right" triggers="focus" :target="`timeline` + kit.id">
      <kit-timeline :kit="kit" v-if="kit"></kit-timeline>
    </b-popover>
  </div>
</template>

<script>
import apiStringMappings from '@/mixins/apiStringMapping'
import KitTimeline from '@/components/elements/KitTimeline'

export default {
  name: 'sampleStatus',
  props: ['kit', 'kitStatus', 'sampleStatus', 'prefix'],
  components: { KitTimeline },
  mixins: [apiStringMappings],
  methods: {
    friendlyStatus: function (key) {
      const keys = {
        'ASSIGNED': 'Kit Available',
        'PROCESSING': 'Processing',
        'UNASSIGNED': 'Kit Available',
        'REQUESTED': 'Packing',
        'ALLOCATED': 'Sent',
        'DISPATCHED_BY_MICROBA': 'Sent',
        'RECEIVED_BY_CUSTOMER': 'Received',
        'RECEIVED_BY_MICROBA': 'Received By Lab',
        'RESULTS_AVAILABLE': 'Results Available',
        'REPLACED': 'Replaced',
        'FAILED_OVERLOADED': 'Error',
        'FAILED_UNDERLOADED': 'Error',
        'FAILED_SWAB_OTHER': 'Error',
        'FAILED_PROCESSING': 'Error',
        'REDEEMED': 'Kit Redeemed', // Not from api
        'MICROBIOME_COACH_SESSION_COMPLETED': 'Results Available'
      }
      const value = keys[key]
      return (value != null) ? value : key
    },
    friendlySubStatus: function (key) {
      const keys = {
        'FAILED_OVERLOADED': 'Swab overloaded',
        'FAILED_UNDERLOADED': 'Swab underloaded',
        'FAILED_SWAB_OTHER': 'Sample failed',
        'FAILED_PROCESSING': 'Sample failed'
      }
      return keys[key] != null ? keys[key] : ''
    },
    fetchToolTips: function (key) {
      const kitAvailableTip = 'This kit has not been shipped and is ready for you to request it to be sent out.'
      const sentTip = 'This kit has been shipped to you via Australia Post, you should receive it within 3-6 business days.'
      const toolTips = {
        'ASSIGNED': kitAvailableTip,
        'PROCESSING': 'We are processing your sample, it takes approximately 4 weeks from receiving your sample at our laboratory to have your Microba Insight Report ready.',
        'UNASSIGNED': kitAvailableTip,
        'REQUESTED': 'This kit is being prepared for dispatch by the Microba team and will be sent as soon as possible.',
        'ALLOCATED': sentTip,
        'DISPATCHED_BY_MICROBA': sentTip,
        'RECEIVED_BY_MICROBA': 'We have received your sample at our laboratory. It will take approximately 4 weeks from receipt for your Microba Insight Report to be ready.',
        'RESULTS_AVAILABLE': `Your Microba Insight Report is ready, please go to the 'Reports' button using the bar to the left hand side of your screen.`,
        'REPLACED': 'This kit has been replaced by Microba.',
        'FAILED_OVERLOADED': 'We have sent you an email regarding your sample, please check your email inbox.',
        'FAILED_UNDERLOADED': 'We have sent you an email regarding your sample, please check your email inbox.',
        'FAILED_SWAB_OTHER': 'We have sent you an email regarding your sample, please check your email inbox.'
      }
      return toolTips[key] ? toolTips[key] : ''
    }
  },
  computed: {
    displayPrefex: function () {
      return (this.prefix) ? `${this.prefix} ` : ''
    },
    displayStatus: function () {
      return (this.sampleStatus) ? this.friendlyStatus(this.sampleStatus) : this.friendlyStatus(this.kitStatus)
    },
    subStatus: function () {
      return (this.sampleStatus) ? this.friendlySubStatus(this.sampleStatus) : ''
    },
    displayTooltip: function () {
      return (this.sampleStatus) ? this.fetchToolTips(this.sampleStatus) : this.fetchToolTips(this.kitStatus)
    },
    className: function () {
      const kitStatus = (this.kitStatus) ? this.kitStatus.toLowerCase().replace(/_/g, '-') : ''
      const sampleStatus = (this.sampleStatus) ? this.sampleStatus.toLowerCase().replace(/_/g, '-') : ''
      return kitStatus + ' ' + sampleStatus
    }
  }
}
</script>

<style scoped lang='scss'>

  /*media-breakpoint-up(sm) {*/
  @media (min-width: 800px) {
    .sampleStatus {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
  /*}*/

  .text-bold{
    font-weight: 500;
  }

  .sampleStatus{
    background: #F4F4F4;
    min-height: 60px;
    height: 100%;

    justify-content: center;
    flex-wrap:wrap;
    text-align: center;
    border-radius: 4px;
    padding:10px;

    .status {
      font-size:1rem;
      margin-bottom:0rem;
      width:100%;

      + .staus-details {
        //if the status details are approved
        margin-top:0.5rem;
      }
    }

    .status-details {
      //if the status details are approved
      width:100%;
      color: #00193D;
      font-family: Roboto;
      font-size: 1rem;
      font-weight: 300;
      line-height: 1.125rem;
      text-align: center;
    }

    &.failed-overloaded{
      color: red;
      h4{
        color: red;
      }
    }

    &.failed-underloaded {
      color: red;
      h4{
        color: red;
      }
    }

    &.failed-swab-other {
      color: red;
      h4{
        color: red;
      }
    }
  }


</style>
<style>
  .popover{
    max-width: 80% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/sampleStatus.vue